import { bool, func } from 'prop-types'

import CodeScanner from '~/src/components/CodeScanner/index.js'

function Page(props) {
  const { openScanner, closeScanner, isScannerOpen, onScanResult } = props
  return (
    <div>
      <button type="button" onClick={() => openScanner()}>
        掃條碼
      </button>
      {isScannerOpen && <CodeScanner {...{ closeScanner, onScanResult }} />}
    </div>
  )
}
Page.propTypes = {
  openScanner: func.isRequired,
  closeScanner: func.isRequired,
  onScanResult: func.isRequired,
  isScannerOpen: bool,
}

export default Page
